// extracted by mini-css-extract-plugin
export default {"legal":"legal_legal__a8Fxs","center":"legal_center__spcpN"};